var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.tipoImport == 0)?_c('div',[_c('CombosGeneradosImportAsignacionVue',{attrs:{"tipoImport":_vm.tipoImport}})],1):_vm._e(),(_vm.tipoImport == 1)?_c('div',[_c('CombosGeneradosImportAsignacionVue',{attrs:{"tipoImport":_vm.tipoImport}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }